/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Soft_Light_Stingray_PrayInputs */

const fr_soft_light_stingray_pray = /** @type {(inputs: Soft_Light_Stingray_PrayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min (%)`)
};

/**

* @param {Soft_Light_Stingray_PrayInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const soft_light_stingray_pray = /** @type {((inputs?: Soft_Light_Stingray_PrayInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_Light_Stingray_PrayInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_soft_light_stingray_pray(inputs)
});